module.exports = __webpack_public_path__ + "static/media/trailer-4.5b9d3b61.png";